export default __webpack_public_path__ + "static/media/img3.dcbe2bcb.jpg";